import React, { useReducer } from 'react'
import { SET_SCROLL_TO_TOP } from 'context/types'
import PageContext from './pageContext'
import PageReducer from './pageReducer'
import { PropTypes } from 'prop-types'

const PageState = ({ children }) => {
  const initialState = {
    scrollToTop: false,
  }

  const [state, dispatch] = useReducer(PageReducer, initialState)

  const setScrollToTop = value => {
    dispatch({ type: SET_SCROLL_TO_TOP, payload: value })
  }

  return (
    <PageContext.Provider
      value={{
        scrollToTop: state.scrollToTop,
        setScrollToTop,
      }}
    >
      {children}
    </PageContext.Provider>
  )
}

PageState.propTypes = {
  children: PropTypes.node,
}

export default PageState
